<script lang="ts">
    import {getInjector, getLocalization} from 'src/core';
    import {pipe} from 'core/utils';
    import {KpFindInDatabasesPresenter} from './kp-find-in-databases.presenter';
    import {loc} from 'shared/utils/pipes';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let recordId: string;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpFindInDatabasesPresenter);
</script>

{#await presenter.getForeignOccurrences(recordId)}
    <KpLoadingBlock/>
{:then foreignOccurrences}
    <div class="div-databases-list">
        <span>{localize(/* @kp-localization centralIndex.NajdeteVDatabazich */ 'centralIndex.NajdeteVDatabazich')}</span>
        {#each foreignOccurrences as foreignOccurrence}
            <span>
                <a class="btn btn-xs btn-default foreign-database-{foreignOccurrence?.databaseId}"
                   title={foreignOccurrence?.availability?.reasonable && (foreignOccurrence?.availability?.free && 'Volný' || 'Nedostupný') || 'Klikněte pro zjištění dostupnosti'}
                   href={foreignOccurrence?.itemUrl}
                   class:btn-info={(foreignOccurrence?.availability && (!foreignOccurrence?.availability?.reasonable || !foreignOccurrence?.availability?.known))}
                   class:btn-success={(foreignOccurrence?.availability && foreignOccurrence?.availability?.reasonable && foreignOccurrence?.availability?.free)}
                   class:btn-danger={(foreignOccurrence?.availability && foreignOccurrence?.availability?.reasonable && !foreignOccurrence?.availability?.free)}>
                    {pipe(foreignOccurrence?.databaseName, loc())}
                </a>
            </span>
        {/each}
    </div>
{/await}